import { useQuery, UseQueryResult } from 'react-query';
import { AdTargetPlace, GetBannerAdExchange } from '@/api/bff_types';
import { GET_BANNER_ADS_QUERY_KEY } from '@/hooks/advertisement/queryKeys';
import { getAdBanner } from '@/utils/graphqlApis';
import { useRecoilValue } from 'recoil';
import { authState } from '@/recoil/auth';

const useGetAdBanner = (
  targetPlace: AdTargetPlace
): UseQueryResult<GetBannerAdExchange | undefined> => {
  const { token } = useRecoilValue(authState);

  const queryData = useQuery(
    [GET_BANNER_ADS_QUERY_KEY[targetPlace]],
    () =>
      getAdBanner(
        {
          request: {
            targetPlace
          }
        },
        token
      ),
    {
      cacheTime: 0,
      staleTime: 0
    }
  );

  return queryData;
};

export default useGetAdBanner;
